import axios from "axios";
import React, { useMemo } from "react";

import { useGoogleSheetsAuthContext } from "./useGoogleSheetAuthContext";

export const useGoogleSheetApi = (p: { spreadsheetId: string }) => {
  const SPREADSHEET_ID = useMemo(() => p.spreadsheetId, []);
  const { accessToken, requestToken } = useGoogleSheetsAuthContext();

  const readSheet = React.useCallback(
    async (range: string) => {
      if (!accessToken) {
        throw new Error("No token");
      }

      const res = await axios.get(
        `https://sheets.googleapis.com/v4/spreadsheets/${SPREADSHEET_ID}/values/${encodeURIComponent(
          range
        )}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );

      return res.data.values ?? [];
    },
    [accessToken]
  );

  return { readSheet };
};
